import { CooperativeComponent } from './cooperative.component';

/**
 * WS5 Phase 3 #9 — the NATIVE `cooperative` UIRouter component-state, replacing the AngularJS
 * component-state that the account-v2 `AccountApp.v2.Cooperative` module registered
 * (`state.config.ts` → `component: "ftCooperative"`). Same name/url/params/data as the v1
 * StateConfig (byte-identical route contract).
 *
 * NOT registered eagerly: in v1 this state only existed when the coop feature set loaded
 * (account-v2 features/index.ts → coop.features.ts `forCompanySpace`) — i.e. a Company space
 * whose company is Cooperative-type (Z8 'Visit Myrtle Beach' — the gate path). Mixed spaces
 * never got it (`Cooperative` is commented out of `forMixedSpace`), so `/m/{slug}/cooperative`
 * fell through to the `otherwise` rule. AppModule.ngDoBootstrap reproduces that gate; an
 * unconditional `UIRouterModule.forChild` registration here made the route reachable on every
 * space type.
 */
export const COOPERATIVE_STATE = {
    name: 'cooperative',
    url: '/{type:\\w}/{slug}/cooperative',
    params: {
        type: { dynamic: true },
        slug: { dynamic: true },
    },
    component: CooperativeComponent,
    data: {
        requiresAuth: true,
        pageClass: 'ft-cooperative-body',
    },
};
